import React from 'react';
import { bool, func, string, array, object } from 'prop-types';
import { layout, position } from 'styled-system';
import styled from 'styled-components';
import Modal from 'react-modal';
import theme from '@airasia-common/libraries/theming/theme';
import Wrapper from '../Wrapper';
import Row from '../Container/Row';
import { SubBodyText, BodyText, H3 } from '../Text/Heading';
import { Variant } from '../../utils/constants';
import Icon from '../Icon';

const StyledModal = styled(Modal)`
  border-radius: 4px 4px 0 0;
  background-color: ${({ theme }) => theme.colors.primaryWhite};
  padding: 0;
  z-index: 100;
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  max-height: 350px;
  overlow-y: scroll;
  ${layout};
  ${position};
`;

const CloseIcon = styled(Icon)`
  cursor: pointer;
`;

const Option = styled(Row)`
  cursor: pointer;
`;

Option.defaultProps = {
  paddding: 0,
  paddingX: 16,
  paddingY: 10,
  justifyContent: 'space-between',
};

Option.displayName = 'Option';

const RightText = props => <SubBodyText color="greyDark" {...props} />;

RightText.displayName = 'RightText';

const OptionText = ({ isSelected, ...restProps }) =>
  isSelected ? (
    <BodyText
      lineHeight="21px"
      fontWeight={500}
      color="secondary"
      {...restProps}
      numberOfLines={1}
    />
  ) : (
    <BodyText
      lineHeight="21px"
      fontWeight={400}
      {...restProps}
      numberOfLines={1}
    />
  );

OptionText.propTypes = {
  isSelected: bool,
};

OptionText.displayName = 'OptionText';

const getItem = (propValue, items) =>
  items.find(({ value }) => value === propValue);

const PickerItemsModal = ({
  items = [],
  value: propValue,
  isOpen,
  onClose,
  onValueChange,
  showRightText,
  modalMobileProps = {},
}) => {
  const { modalStyle, title } = modalMobileProps;
  const selectedItemIndex = propValue
    ? items.indexOf(getItem(propValue, items))
    : -1;

  const handleOptionClick = (item, index) => event => {
    event.preventDefault();
    event.stopPropagation();
    onValueChange(item, index);
  };

  return isOpen ? (
    <StyledModal
      width={1}
      isOpen={isOpen}
      onClose={onClose}
      style={{
        overlay: {
          background: 'rgb(0, 0, 0, 0.8)',
          zIndex: 999,
        },
      }}
      {...modalStyle}
    >
      {title && (
        <Wrapper
          height="56px"
          display="flex"
          alignItems="center"
          justifyContent={'space-between'}
          padding="0 16px"
          borderBottom={`1px solid ${theme.colors.greyLight}`}
        >
          <H3 fontSize={'16px'} lineHeight={'24px'}>
            {title}
          </H3>
          <CloseIcon icon="CloseIcon" onClick={onClose} />
        </Wrapper>
      )}

      {items.map((item, index) => {
        const isSelected = selectedItemIndex === index;
        return (
          <Option key={index} onClick={handleOptionClick(item, index)}>
            <OptionText isSelected={isSelected}>{item.label}</OptionText>
            {showRightText && <RightText>{item.rightLabel}</RightText>}
            {!showRightText && isSelected && (
              <Icon icon="CheckIcon" variant={Variant.Success} />
            )}
          </Option>
        );
      })}
    </StyledModal>
  ) : (
    <></>
  );
};

PickerItemsModal.propTypes = {
  items: array,
  value: string,
  onClose: func,
  onValueChange: func,
  showRightText: bool,
  isOpen: bool,
  modalMobileProps: object,
};

export default PickerItemsModal;
